import { Customer, User } from "types/settings";
import http from "lib/http/httpClient";


export const getUsers = async (userType?: string, roleId?: number, search?: string): Promise<User[]> => {
  try {
    const params = new URLSearchParams();

    if (userType) params.append("user_type", userType);
    if (roleId) params.append("role_id", roleId.toString());
    if (search) params.append("search", search);

    return http.get(`/api/v1/cp/users${params.toString() ? `?${params}` : ""}`);
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const deleteUser = async (user_id: string) => {
  try {
    const response = await http.delete(`/api/v1/cp/users/${user_id}`);
    return response;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

export const updateUser = async (user_id: string, userData: any) => {
  try {
    const response = await http.put(`/api/v1/cp/users/${user_id}`, userData);
    return response;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const createUser = async (userData: any) => {
  try {
    const response = await http.post('/api/v1/cp/users/create', userData);
    return response;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const resendOnboardingEmail = async (user_id: string) => {
  try {
    const response = await http.post(`/api/v1/cp/users/${user_id}/onboarding-email/resend`);
    return response;
  } catch (error) {
    console.error('Error resending onboarding email:', error);
    throw error;
  }
};

export const fetchCustomers = async(): Promise<Customer[]> => {
    try{
        const response = await http.get('/api/v1/cp/users/get-all-customers');
        return response;
    } catch (error) {
        console.error("Error fetching customer ids: ", error);
        throw error;
    }
}

export const fetchCustomersForUser = async (): Promise<Customer[]> => {
  try {
    const response = await http.get('/api/v1/cp/users/my-customers');
    return response;
  } catch (error) {
    console.error('Error fetching customers for user:', error);
    throw error;
  }
};

export const fetchInternalUsers = async (): Promise<{ user_id: string; name: string; email: string }[]> => {
  try {
    const response = await http.get('/api/v1/cp/users/internal-users');
    return response;
  } catch (error) {
    console.error('Error fetching internal user suggestions:', error);
    throw error;
  }
};